//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { MENU_PLATFORMS, TENANT_LIST } from '@/utils/constant';
import jsonEdit from '@/components/jsonEdit/index.vue';
import wenetButton from '../Menu-new/components/wenet-button.vue';
import diff from '@/components/codeDiff';
import config from '@/config';
import { getFile, addFile, editFile, deleteFile } from '@/api/git';

const formattedJson = (str) => {
  const defaultStr = str;
  try {
    return JSON.stringify(JSON.parse(str), null, '\t');
  } catch (err) {
    console.log(err);
  }
  return defaultStr;
};
const getAllIds = (list) => {
  let ids = [];
  list.forEach((item) => {
    if (item.layout_json !== item.stable_layout_json) {
      ids.push(item.id);
    }
    ids = [...ids, ...getAllIds(item.children)];
  });
  return ids;
};
export default {
  components: {
    jsonEdit,
    diff,
    wenetButton,
  },
  data() {
    const checkCode = (rule, value, callback) => {
      const reg = /^[A-Za-z-_0-9]{3,100}$/;
      if (!reg.test(value)) {
        return callback(new Error('只能是大小写英文字母、数字以及-_字符，长度为3到100'));
      }
      callback();
    };
    return {
      PLATFORMS: MENU_PLATFORMS,
      operation: 'create',
      listData: [], // 菜单树(全部)
      filterMenuTree: [], // 菜单树(筛选)
      menuOptions: [],
      count: 0,
      appOptions: [],
      formObj: {},
      oldSearchObj: {},
      searchObj: {
        appid: '',
        platform: Number(this.$route.query.platform) || 2,
        keyword: this.$route.query.keyword || '',
        display: Number(this.$route.query.display) || 0,
      },
      jsonEditTitle: '',
      rules: {
        name: [
          {
            required: true,
            message: '请输入菜单名称',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入菜单Code',
            trigger: 'blur',
          },
          { validator: checkCode, trigger: 'blur' },
        ],
      },
      opDialogVisible: false,
      roleDialogVisible: false,
      submitDisable: false,
      showJson: false,
      jsonData: '',
      old_layout_json: '',
      menuLoading: false, // 父级菜单加载loading
      selctData: [], // 同步数据
      jsonDiff: {
        show: false,
        oldString: '',
        newString: '',
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getUserInfo', 'getElementList', 'getTenantInfo']), // user 模块名称
    currentBranch() {
      const env = process.env.VUE_APP_ENV; // ['dev', 'test', 'pre', 'prod']
      const tenant = TENANT_LIST?.[env]?.[this.getTenantInfo.id];
      const domain = window?.location?.host;
      const tenantName =
        tenant?.git_record || tenant?.[domain]?.git_record
          ? tenant?.name_en || tenant?.[domain]?.name_en
          : undefined;
      return tenantName ? `${tenantName}/${env}` : undefined;
    },
    jurisdiction() {
      return {
        menuManage: this.getElementList.includes('menu-manage'),
      };
    },
    // 是否展示发布操作
    showissue() {
      return [
        'production',
        // 'preview', 'test', 'development'
      ].includes(config.env);
    },
  },
  mounted() {
    this.loadAppOption();
    this.init();
  },
  methods: {
    init() {
      if (!this.searchObj.appid) {
        this.searchObj.appid = Number(sessionStorage.getItem('app_id'));
        this.searchObj.platform = Number(sessionStorage.getItem('platform') || 2);
      } else {
        sessionStorage.setItem('app_id', this.searchObj.appid);
        sessionStorage.setItem('platform', this.searchObj.platform);
      }
      if (this.searchObj.appid) {
        this.loadListData();
      }
    },
    searchList() {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.oldSearchObj = Object.assign({}, this.searchObj);
      this.timer = setTimeout(() => {
        this.$router.push({ query: this.searchObj });
        sessionStorage.setItem('app_id', this.searchObj.appid);
        sessionStorage.setItem('platform', this.searchObj.platform);
        this.loadListData();
        this.selctData = [];
      }, 300);
    },
    resetForm() {
      this.searchObj.keyword = '';
      this.searchObj.display = 0;
      this.searchList();
    },
    openJsonEdit() {
      this.jsonData = this.formObj.layout_json;
      this.jsonEditTitle = this.formObj.name;
      this.$nextTick(() => {
        this.showJson = true;
      });
    },
    saveJson(json) {
      this.formObj.layout_json = JSON.stringify(JSON.parse(json));
      this.$nextTick(() => {
        this.showJson = false;
      });
    },
    // 菜单树
    loadListData() {
      const url = this.$api.getMenuTree;
      const data = {
        appid: this.searchObj.appid,
        platform: this.searchObj.platform,
      };
      const cb = (data) => {
        this.count = data.total;
        this.listData = data.data;
        this.filterMenuTree = this.filterMenu(this.listData, this.searchObj);
      };
      this.$request({ url, data, cb });
    },
    // 菜单列表
    async loadMenuOption(keyword = '') {
      this.menuLoading = true;
      try {
        const data = await this.$request({
          url: this.$api.getMenuList,
          data: {
            keyword,
            appid: this.searchObj.appid,
            platform: this.searchObj.platform,
            page_size: 99999,
          },
        });
        this.menuOptions = data.data;
        this.menuOptions.push({
          id: 0,
          code: 'root',
          name: 'Root',
        });
        this.menuLoading = false;
      } catch (err) {
        console.log(err);
        this.menuOptions = [];
        this.menuOptions.push({
          id: 0,
          name: 'Root',
        });
        this.menuLoading = false;
      }
    },
    // 获取菜单信息
    async getMenuInfo(id) {
      try {
        const menuInfo = await this.$request({ url: this.$api.getMenu, data: { id } });
        this.formObj = Object.assign({}, menuInfo);
        this.old_layout_json = menuInfo.layout_json || '';
        if (this.currentBranch) {
          const filePath = this.getFilePath(menuInfo);
          let gitJsonExist = false;
          try {
            const file = await getFile({ ref: this.currentBranch, filePath });
            if (file?.body) {
              gitJsonExist = JSON.parse(file?.body)?.content;
            }
          } catch (e) {
            console.log(e);
            this.$message.info('没有找到对应的版本文件，保存将创建一个新的版本文件');
          }
          this.formObj = Object.assign(menuInfo, {
            file_path: filePath,
            layout_json: menuInfo.layout_json,
            git_layout_json_exist: gitJsonExist,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    loadAppOption() {
      const url = this.$api.getAppList;
      const data = { page_size: 999999 };
      const cb = (data) => {
        this.appOptions = data.data;
        if (!this.searchObj.appid) {
          this.searchObj.appid = this.appOptions[0].id;
          this.init();
        }
      };
      this.$request({ url, data, cb });
    },
    submitForm() {
      if (this.submitDisable) {
        return;
      }
      if (this.$refs.wenet_btn?.isError()) {
        return;
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.opDialogVisible = false;
        this.submitDisable = true;
        const { id } = this.formObj;
        const url = id ? this.$api.updateMenu : this.$api.createMenu;
        const msg = id ? '修改成功' : '创建成功';
        let layoutJson = this.formObj.layout_json || '{}';
        // 小程序，需要将json中的表达式，注入8位id
        if (layoutJson && this.searchObj.platform === 1) {
          try {
            layoutJson = await this.$expManage.resolveModifiedJson(layoutJson);
          } catch (e) {
            this.submitDisable = false;
            this.$alert(e.message);
            throw e;
          }
        }
        // 为 json 增加缩进和换行
        layoutJson = JSON.stringify(JSON.parse(layoutJson), null, 2);
        let data = {
          code: this.formObj.code,
          parent_code: this.formObj.parent_code,
          name: this.formObj.name,
          path: this.formObj.path,
          icon: this.formObj.icon || '-',
          order_weight: this.formObj.order_weight,
          display: this.formObj.display,
          appid: this.searchObj.appid,
          layout_json: layoutJson,
          platform: this.searchObj.platform,
          json_type: this.formObj.json_type,
        };
        if (id) {
          data = {
            id,
            name: this.formObj.name,
            order_weight: this.formObj.order_weight,
            display: this.formObj.display,
            appid: this.searchObj.appid,
            path: this.formObj.path,
            icon: this.formObj.icon || '-',
            layout_json: layoutJson,
            platform: this.searchObj.platform,
            parent_code: this.formObj.parent_code,
            last_layout_json: this.old_layout_json,
          };
        }
        console.log('data :>> ', data);
        const cb = () => {
          this.old_layout_json = '';
          this.submitDisable = false;
          this.$message({
            message: msg,
            type: 'success',
          });
          this.loadListData();
        };
        const type = 'post';
        try {
          await this.$request({ url, data, cb, type });
          // 先用将配置保存到数据库，再将版本记录保存到git仓库
          if (this.currentBranch) {
            console.log(url, data, cb, type);
            if (this.formObj.git_layout_json_exist) {
              console.log('{} layoutJson {}', layoutJson);
              editFile({
                branchName: this.currentBranch,
                filePath: this.formObj.file_path,
                content: layoutJson,
                staffName: this.getUserInfo.staffname,
                moduleName: '菜单管理',
              })
                .then(() => {
                  console.log('git 编辑成功');
                })
                .catch((err) => {
                  this.$message.error(`git 编辑失败：${err}`);
                });
            } else {
              addFile({
                branchName: this.currentBranch,
                filePath: this.formObj.file_path,
                content: layoutJson,
                staffName: this.getUserInfo.staffname,
                moduleName: '菜单管理',
              })
                .then(() => {
                  console.log('git 新增成功');
                })
                .catch((err) => {
                  this.$message.error(`git 新增失败：${err}`);
                });
            }
          }
        } catch (err) {
          console.log(err);
          this.submitDisable = false;
        }
      });
    },
    //  -----表格勾选-----
    checkSelectable(row) {
      return row.layout_json !== row.stable_layout_json;
    },
    setChildren(children, type) {
      children.forEach((j) => {
        this.toggleSelection(j, type);
        if (j.children) {
          this.setChildren(j.children, type);
        }
      });
    },
    toggleSelection(row, select) {
      if (row) {
        if (row.layout_json === row.stable_layout_json) {
          return;
        }
        this.$nextTick(() => {
          this.$refs.menuTable && this.$refs.menuTable.toggleRowSelection(row, select);
        });
      }
    },
    handleSelectionChange(val) {
      setTimeout(() => {
        // 防止全选判断失误
        this.selctData = val.map((item) => item.id);
      }, 100);
    },
    // 规则适用范围勾选数据行
    handleRowSelect(selection, row) {
      const hasSelect = selection.some((el) => {
        return row.id === el.id;
      });
      if (hasSelect) {
        if (row.children) {
          // 解决子组件没有被勾选到
          this.setChildren(row.children, true);
        }
      } else {
        if (row.children) {
          this.setChildren(row.children, false);
        }
      }
    },
    handleSelectAll() {
      const tableData = this.filterMenuTree;
      const allIdList = getAllIds(tableData);
      let type = false;
      if (this.selctData.length < allIdList.length) {
        type = true;
      }
      tableData.forEach((el) => {
        if (el.children) {
          // 解决子组件没有被勾选到
          this.setChildren(el.children, type);
        }
      });
    },
    // -------end-----------
    deleteOperation(id) {
      const url = this.$api.deleteMenu;
      const type = 'post';
      const cb = () => {
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.loadListData();
      };
      this.$request({ url, cb, type, data: { id } });
    },
    detection() {
      try {
        this.$expManage.getJsons(this.listData);
        this.$message({
          message: '检测布局json状态正常',
          type: 'success',
        });
      } catch (e) {
        this.$alert(e.message);
        throw e;
      }
    },
    handleAdd() {
      this.operation = 'create';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = { display: 1, parent_code: 'root', layout_json: '{}' };
      this.old_layout_json = '{}';
      this.opDialogVisible = true;
      this.loadMenuOption();
    },
    handleSubAdd(index, data) {
      this.operation = 'create';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = { display: 1, parent_code: data.code, layout_json: '{}' };
      this.old_layout_json = '{}';
      this.opDialogVisible = true;
      this.loadMenuOption();
    },
    handleEdit(index, data) {
      this.operation = 'update';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = Object.assign({}, data);
      this.old_layout_json = data.layout_json || '';
      // 获取最新的菜单列表数据
      this.getMenuInfo(data.id);
      this.opDialogVisible = true;
      this.loadMenuOption();
    },
    handleDelete(index, data) {
      this.$confirm('是否删除该菜单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteOperation(data.id);
          // 先删除菜单，再删除 git 仓库中的版本记录
          if (this.currentBranch) {
            deleteFile({
              branchName: this.currentBranch,
              filePath: data.file_path,
              staffName: this.getUserInfo.staffname,
              moduleName: '菜单管理',
            })
              .then(() => {
                console.log('版本记录删除成功');
              })
              .catch((err) => {
                this.$message.error(`git 新增失败：${err}`);
              });
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    viewDiff(row) {
      this.jsonDiff = {
        show: true,
        oldString: formattedJson(row.stable_layout_json),
        newString: formattedJson(row.layout_json),
      };
    },
    async issue() {
      if (this.selctData.length < 1) {
        this.$message.error('请选择数据再操作');
        return;
      }
      try {
        await this.$confirm(`同步菜单${this.selctData.length}个`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        await this.$request({ url: this.$api.releaseMenuJson, data: { ids: this.selctData } });
        this.$message({
          message: '发布成功',
          type: 'success',
        });
        this.loadListData();
      } catch (err) {
        console.log(err);
      }
    },
    async issueRow(row) {
      try {
        await this.$confirm(`确定发布该菜单吗(${row.name || row.code})?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        await this.$request({ url: this.$api.releaseMenuJson, data: { ids: [row.id] } });
        this.$message({
          message: '发布成功',
          type: 'success',
        });
        this.loadListData();
      } catch (err) {
        console.log(err);
      }
    },
    openDraggablePlatform() {
      if (this.formObj.id) {
        const routerUrl = this.$router.resolve({
          path: `/draggablePlatform/${this.formObj.id}`,
        });
        window.open(routerUrl.href, '_blank');
      } else {
        this.$message({
          type: 'warning',
          message: '请先创建菜单后，再进行模板编辑!',
        });
      }
    },
    // 获取配置文件名
    getFilePath(item) {
      const appName = this.appOptions
        .find((app) => app.id === item.appid)
        ?.name?.split(' ')
        ?.join('-');
      if (appName && item.code) {
        return `${appName}/${item.code}.json`;
      }
      console.log('获取配置文件名失败', item);
      return '';
    },
    filterMenu(tree, { keyword = '', display = 0 }) {
      return tree
        .map((item) => {
          return {
            ...item,
            children: this.filterMenu(item.children, { keyword, display }),
            file_path: this.getFilePath(item),
          };
        })
        .filter((item) => {
          if (item.children && item.children.length) {
            return true;
          }
          // 模糊搜索
          const condition1 = !![item.name, item.code, item.path].find((val) => {
            return val.includes(keyword);
          });
          // 显示状态
          let condition2 = true;
          if (display > 0) {
            condition2 = `${item.display}` === `${display}`;
          }
          return condition1 && condition2;
        });
    },
  },
};
